export const POST_HRMS_DROPZONE_REMOVED_FILE = 'POST_HRMS_DROPZONE_REMOVED_FILE'



// WEBPACK FOOTER //
// ./src/store/modules/hrmsDropzone/mutation-types.js